const Version = "1.11.5"; export {Version};